"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PlayerCore = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _Page = _interopRequireDefault(require("./Page"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _reactRedux = require("react-redux");
var _allElements = _interopRequireDefault(require("../../../allElements.js"));
var _player = require("../../../selectors/player.js");
var _builder = require("../../../selectors/builder.js");
var _allTemplates = require("../../../allTemplates.js");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PlayerCore = exports.PlayerCore = /*#__PURE__*/function (_React$Component) {
  _inherits(PlayerCore, _React$Component);
  function PlayerCore() {
    var _this;
    _classCallCheck(this, PlayerCore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PlayerCore, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getElementType", function (element) {
      var elementType = (0, _find2["default"])(_allElements["default"], {
        code: element.type
      });
      return elementType || {};
    });
    return _this;
  }
  _createClass(PlayerCore, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        pages = _this$props.pages,
        waitingForAjax = _this$props.waitingForAjax,
        settings = _this$props.settings,
        accommodations = _this$props.accommodations,
        allQuestionStartNumbers = _this$props.allQuestionStartNumbers,
        showPrintHeaderFlowName = _this$props.showPrintHeaderFlowName,
        defaultValueVariables = _this$props.defaultValueVariables,
        isPreviewMode = _this$props.isPreviewMode;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: waitingForAjax
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, null, pages.map(function (elements, index) {
        return /*#__PURE__*/_react["default"].createElement(_Page["default"], {
          key: index,
          title: showPrintHeaderFlowName ? settings.name : '',
          pageNumber: index + 1
        }, elements.map(function (element) {
          var elementType = _this2._getElementType(element);
          if (element.settings.printSkip) {
            return null;
          }
          if (!elementType.hasPrintVersion || element.settings.printOverrideDefault) {
            return element.settings.printPlaceholder ? /*#__PURE__*/_react["default"].createElement("div", {
              key: element.id,
              className: _style["default"].element
            }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: element.settings.printPlaceholder
            })) : null;
          }
          var ElementPlayer = elementType.player;
          var initialValues = {
            value: _this2.props.answers[element.id] !== undefined ? _this2.props.answers[element.id] : elementType.getPlayerInitialValue(element.settings, isPreviewMode ? undefined : defaultValueVariables)
          };

          // Get the custom template if there is a print version
          var template;
          var templateExtraProps;
          var customTemplate = (0, _allTemplates.getTemplate)('components', element.type, element.settings.template);
          if (customTemplate && customTemplate.hasPrintVersion) {
            template = customTemplate.component;
            templateExtraProps = {
              templateSettings: _objectSpread(_objectSpread({}, customTemplate.defaultSettings), element.settings.templateSettings),
              storage: {},
              setToStorage: function setToStorage() {},
              isPrintMode: true
            };
          }
          var elementAccommodations = element.settings.overrideAccommodations ? element.settings.accommodations : accommodations;
          elementAccommodations.masking = false;
          var extraProps = {};
          if (settings.showQuestionNumbers && allQuestionStartNumbers[element.id]) {
            extraProps.showQuestionNumbers = true;
            extraProps.startQuestionNumber = allQuestionStartNumbers[element.id];
          }
          var bubbleMessages = element.settings.bubbleMessages || [];
          var adjustedSettings = _objectSpread(_objectSpread({}, elementType.builderInitialValues), element.settings);
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].element + ' ' + _style["default"].readOnly,
            key: element.id
          }, bubbleMessages.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].bubbleMessage,
              key: item.id
            }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: item.text
            }));
          }), /*#__PURE__*/_react["default"].createElement("form", null, /*#__PURE__*/_react["default"].createElement(ElementPlayer, _extends({
            form: 'player' + element.id,
            key: element.id,
            componentId: element.id,
            settings: adjustedSettings,
            initialValues: initialValues,
            template: template,
            templateExtraProps: templateExtraProps,
            showRequiredState: settings.showRequiredState,
            accommodations: elementAccommodations,
            dynamicUserLists: _this2.props.dynamicUserLists,
            dynamicUserListsValues: _this2.props.dynamicUserListsValues,
            isPrintMode: true
          }, extraProps))));
        }));
      })));
    }
  }]);
  return PlayerCore;
}(_react["default"].Component);
_defineProperty(PlayerCore, "propTypes", {
  answers: _propTypes["default"].object,
  settings: _propTypes["default"].object,
  accommodations: _propTypes["default"].object,
  allQuestionStartNumbers: _propTypes["default"].object,
  waitingForAjax: _propTypes["default"].bool,
  pages: _propTypes["default"].array,
  dynamicUserLists: _propTypes["default"].array,
  dynamicUserListsValues: _propTypes["default"].object,
  showPrintHeaderFlowName: _propTypes["default"].bool,
  defaultValueVariables: _propTypes["default"].object,
  isPreviewMode: _propTypes["default"].bool
});
_defineProperty(PlayerCore, "defaultProps", {
  settings: {},
  answers: {},
  showPrintHeaderFlowName: false,
  defaultValueVariables: {}
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    answers: state.flow.player.answers,
    settings: state.flow.player.settings,
    accommodations: (0, _player.getComposedAccommodations)(state.flow.player),
    allQuestionStartNumbers: (0, _player.getAllQuestionStartNumbers)(state.flow.player),
    waitingForAjax: state.flow.player.waitingForAjax,
    pages: (0, _player.getPagesForPrintMode)(state.flow.player),
    dynamicUserLists: state.flow.builder.dynamicUserLists,
    dynamicUserListsValues: props.userLists || (0, _builder.getFakeDynamicUserListsValues)(state.flow.builder)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(PlayerCore);